'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _pluralize = require('pluralize');

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sf = function sf(num) {
  var format = num > 1000 ? '0a' : '0';
  format = num > 1000000 ? '0.0a' : format;
  return (0, _numeral2.default)(num).format(format);
};
var textTransform = {
  textTransform: 'none'
};

var dividerStyle = { borderRight: '1px solid #ccc' };

var BasicReportSummary = function BasicReportSummary(_ref) {
  var influencerCount = _ref.influencerCount,
      assetCount = _ref.assetCount,
      totalReach = _ref.totalReach,
      totalImpressions = _ref.totalImpressions,
      totalEngagements = _ref.totalEngagements,
      totalViews = _ref.totalViews,
      adsCount = _ref.adsCount;
  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, color: 'pink' },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table,
        { basic: 'very' },
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 4 },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Group,
                { widths: adsCount ? 'three' : 'two', size: 'small' },
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  { color: 'grey' },
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    influencerCount
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    (0, _pluralize2.default)('Influencer', influencerCount)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  { color: 'grey' },
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    assetCount
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    (0, _pluralize2.default)('Asset', assetCount)
                  )
                ),
                adsCount ? _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  { color: 'grey' },
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    adsCount
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    (0, _pluralize2.default)('Ad', adsCount)
                  )
                ) : null
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 12 },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Group,
                { widths: 'four' },
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    sf(totalViews)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    'Views'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    sf(totalReach)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    'Reach'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    sf(totalImpressions)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    'Impressions'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Value,
                    { style: textTransform },
                    sf(totalEngagements)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic.Label,
                    null,
                    'Engagements'
                  )
                )
              )
            )
          )
        )
      )
    )
  );
};

BasicReportSummary.propTypes = {
  influencerCount: _propTypes2.default.number.isRequired,
  assetCount: _propTypes2.default.number.isRequired,
  totalReach: _propTypes2.default.number.isRequired,
  totalImpressions: _propTypes2.default.number.isRequired,
  totalEngagements: _propTypes2.default.number.isRequired,
  totalViews: _propTypes2.default.number.isRequired,
  adsCount: _propTypes2.default.number.isRequired
};

exports.default = BasicReportSummary;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-summary/index.js
 ** module id = 2616
 ** module chunks = 0
 **/